import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Button from "wonderbly-components/lib/Button";
import CanvasDrawerContent from "./CanvasDrawerContent";
import CanvasDrawerLabel from "./CanvasDrawerLabel";
import CanvasDrawerPrompt from "./CanvasDrawerPrompt";

import "./CanvasDrawers.scss";
import SaveForLater from "../SaveForLater";

// Some drawers rely on the product form's content to work correctly.
const drawersThatNeedProductForm = [
  "adventurer",
  "multi_adventurer",
  "multi_birthday",
];
const visibleDrawersLength = (drawers = []) => {
  return drawers.filter((d) => d.sliceType !== "hidden_default_value").length;
};

const CanvasDrawers = (props) => (
  <div className="canvas-drawers-hold">
    <div
      className={cx("canvas-drawers", {
        "canvas-drawers-fixed": props.isFixed,
      })}
    >
      <div className="canvas-drawers-content-wrap">
        {props.drawers.other.map((drawer, index) => (
          <CanvasDrawerContent
            key={`${drawer.sliceType}-${index}`}
            index={index}
            activeDrawer={props.activeDrawer}
            title={drawer.primary.title}
            description={drawer.primary.description}
            cancelCta={props.cancelCta}
            prismicProduct={props.prismicProduct}
            productId={props.productId}
            onCancelDrawer={props.handleCancelDrawer}
            onToggleDrawer={props.handleToggleDrawer}
            completedDrawersMap={props.completedDrawersMap}
            drawer={drawer}
            form={
              drawersThatNeedProductForm.includes(drawer.sliceType) &&
              props.drawers.form
            }
            onOpenNextAvailableDrawer={props.handleOpenNextAvailableDrawer}
          />
        ))}
      </div>
      <div
        className={cx("canvas-drawers-wrap", {
          "canvas-drawers-wrap--multi":
            visibleDrawersLength(props.drawers.other) > 5,
        })}
      >
        <div className="container-guttered expanded canvas-drawers-wrap-container">
          <div className="canvas-drawers-label-wrapper display-none-if-no-js">
            {props.drawers.other.map((drawer, index) => {
              return (
                /* can't filter out as we need the correct index passed down  */
                drawer.sliceType !== "hidden_default_value" && (
                  <CanvasDrawerLabel
                    key={`${drawer.sliceType}-${index}`}
                    index={index}
                    prismicProduct={props.prismicProduct}
                    productId={props.productId}
                    activeDrawer={props.activeDrawer}
                    onToggleDrawer={props.handleToggleDrawer}
                    drawer={drawer}
                    completedDrawers={props.completedDrawersMap.complete}
                  />
                )
              );
            })}
          </div>
          <div
            className={cx("canvas-drawers-button", {
              "canvas-drawers-button--loading": props.cartPending,
            })}
          >
            {!props.isCartItem && props.showSaveForLater && (
              <SaveForLater
                productId={props.productId}
                productName={props.productName}
              />
            )}
            {props.isAllDrawersComplete ? (
              <Button
                onClick={props.onSubmitDrawers}
                disabled={props.cartPending}
              >
                {props.completedText}
              </Button>
            ) : (
              <Button
                onClick={props.handleOpenNextAvailableDrawer}
                disabled={!!props.activeDrawer}
              >
                {props.continueText}
              </Button>
            )}
            {props.showCanvasPrompt && (
              <CanvasDrawerPrompt
                {...props.checkWork}
                onSubmitDrawers={props.onSubmitDrawers}
                setActiveDrawer={props.setActiveDrawer}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

CanvasDrawers.propTypes = {
  isFixed: PropTypes.bool,
  completedDrawersMap: PropTypes.shape({
    all: PropTypes.arrayOf(PropTypes.string.isRequired),
    complete: PropTypes.arrayOf(PropTypes.string.isRequired),
    incomplete: PropTypes.arrayOf(PropTypes.string.isRequired),
  }),
  drawers: PropTypes.shape({
    form: PropTypes.object,
    other: PropTypes.arrayOf(
      PropTypes.shape({
        sliceType: PropTypes.string.isRequired,
        primary: PropTypes.shape({
          title: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
            .isRequired,
          description: PropTypes.array,
          tabDefaultText: PropTypes.string,
          tabCompleteTitle: PropTypes.string,
          tabSubtitle: PropTypes.string,
          saveForLater: PropTypes.shape(),
        }),
      })
    ),
  }),
  activeDrawer: PropTypes.string,
  cancelCta: PropTypes.string.isRequired,
  isAllDrawersComplete: PropTypes.bool.isRequired,
  handleCancelDrawer: PropTypes.func.isRequired,
  handleToggleDrawer: PropTypes.func.isRequired,
  handleOpenNextAvailableDrawer: PropTypes.func.isRequired,
  onSubmitDrawers: PropTypes.func.isRequired,
  cartPending: PropTypes.bool.isRequired,
  completedText: PropTypes.string.isRequired,
  continueText: PropTypes.string.isRequired,
  prismicProduct: PropTypes.object,
  productName: PropTypes.string.isRequired,
  productId: PropTypes.string.isRequired,
  isCartItem: PropTypes.bool,
  showSaveForLater: PropTypes.bool,
  checkWork: PropTypes.shape({
    show: PropTypes.bool,
    title: PropTypes.string,
    description: PropTypes.string,
    ctaBackText: PropTypes.array,
    ctaHelper: PropTypes.string,
    ctaText: PropTypes.string,
    drawerKey: PropTypes.string,
  }),
  showCanvasPrompt: PropTypes.bool,
  setActiveDrawer: PropTypes.func,
};

export default CanvasDrawers;
